<app-page-header [title]="pageTitle()">
    <app-page-command-group>
        @if (editMode() || newMode()) {
            <app-page-command name="save" [disabled]="!formValid()" [action]="saveAction()" [requiredPermissions]="savePermissions()"></app-page-command>
            <app-page-command name="cancel" [action]="cancelAction()"></app-page-command>
        }
        @else {
            @if (allowEditMode()) {
                <app-page-command name="edit" [action]="editAction()" [requiredPermissions]="editPermissions()"></app-page-command>
            }
            @if (allowNewMode()) {
                <app-page-command name="new" [action]="newAction()" [requiredPermissions]="newPermissions()"></app-page-command>
            }

            @for (pageCommand of customCommands() ?? []; track pageCommand.name) {
                <app-page-command [name]="pageCommand.name" [action]="pageCommand.action" [icon]="pageCommand.icon" [text]="pageCommand.text" [requiredPermissions]="$safeNavigationMigration(pageCommand.requiredPermissions?.join(','))"></app-page-command>
            }
        }
    </app-page-command-group>
</app-page-header>

<ng-content></ng-content>
<app-page-footer>
    <app-page-command-group>
        @if (editMode() || newMode()) {
            <app-page-command name="save" [disabled]="!formValid()" [action]="saveAction()" [requiredPermissions]="savePermissions()"></app-page-command>
            <app-page-command name="cancel" [action]="cancelAction()"></app-page-command>
        }
    </app-page-command-group>
</app-page-footer>